import { cn } from "@/lib/utils";
import { ROLE_LABELS } from "@/lib/api";

export function Logo({ className, compact, wm = 22, tone = "light" }) {
  return (
    <div
      className={cn("ta-lockup", tone === "dark" ? "on-dark" : "on-light", className)}
      style={{ "--wm": `${wm}px` }}
      data-testid="brand-logo"
    >
      <div className="ta-icon"><span>ta</span></div>
      {!compact && (
        <div className="ta-type">
          <div className="ta-word"><span className="t">true</span><span className="a">academy</span></div>
          <div className="ta-rule"></div>
        </div>
      )}
    </div>
  );
}

const ROLE_STYLES = {
  super_admin: "bg-[#0D0F12] text-white border-transparent dark:bg-white dark:text-[#0D0F12]",
  trainer: "bg-[#1779AC]/10 text-[#1779AC] border-[#1779AC]/20 dark:text-[#4fc0ea]",
  internal_staff: "bg-[#33B6E4]/10 text-[#1779AC] border-[#33B6E4]/25 dark:text-[#5cc7ef]",
  partner: "bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700",
};

export function RoleBadge({ role }) {
  return (
    <span
      data-testid={`role-badge-${role}`}
      className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium", ROLE_STYLES[role])}
    >
      {ROLE_LABELS[role] || role}
    </span>
  );
}

export function Avatar({ src, name, size = 40, className }) {
  const initials = (name || "?")
    .split(" ")
    .map((n) => n[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  return (
    <div
      className={cn("relative shrink-0 overflow-hidden rounded-full bg-secondary grid place-items-center", className)}
      style={{ width: size, height: size }}
    >
      {src ? (
        <img src={src} alt={name} className="h-full w-full object-cover" />
      ) : (
        <span className="text-xs font-semibold text-muted-foreground">{initials}</span>
      )}
    </div>
  );
}

export function ProgressBar({ value, className }) {
  return (
    <div className={cn("h-2 w-full overflow-hidden rounded-full bg-slate-200 dark:bg-slate-800", className)}>
      <div
        className="h-full rounded-full bg-[#33B6E4] transition-all duration-500 ease-out"
        style={{ width: `${Math.min(100, Math.max(0, value || 0))}%` }}
      />
    </div>
  );
}
